import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router } from '@angular/router';
import { IonicModule } from '@ionic/angular/lazy';;

@Component({
  selector: 'app-unauthorized',
  templateUrl: './unauthorized.component.html',
  styleUrls: ['./unauthorized.component.scss'],
  standalone: true,
  imports: [IonicModule]
})
export class UnauthorizedComponent implements OnInit {

  constructor(
    private location: Location,
    private router: Router
  ) {}

  ngOnInit(): void {}

  goBack(): void {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/']);
    }
  }
  goHome(): void {
    this.router.navigate(['/']);
  }
}
